import React from "react";
import { motion } from "framer-motion";
import { STATS } from "../lib/data";

const fade = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] } },
};

const ChiSiamo = () => {
  return (
    <section
      id="chi-siamo"
      className="relative py-28 md:py-40 bg-pw overflow-hidden"
      data-testid="chi-siamo-section"
    >
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-16 items-center">
        {/* Left text */}
        <motion.div
          variants={fade}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          className="lg:col-span-7"
        >
          <div className="flex items-center gap-4 mb-8">
            <span className="gold-line" />
            <span className="overline">Chi Siamo</span>
          </div>

          <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl leading-[1.1] text-[var(--pw-text)]">
            Lo studio di <em className="text-[var(--pw-gold)]">Music Planner</em><br />
            che porta in scena le vostre emozioni.
          </h2>

          <div className="mt-10 space-y-6 text-[var(--pw-text)]/75 font-light text-base md:text-lg leading-relaxed max-w-2xl">
            <p>
              Proscenio Wedding nasce dalla passione per la musica live e dal mestiere antico
              del palcoscenico. Da aprile 2023 facciamo parte dei servizi musicali offerti da
              <span className="text-[var(--pw-gold)]"> Proscenio Solutions di Stefano Ongaro</span>,
              ampliando un'esperienza professionale di oltre dieci anni.
            </p>
            <p>
              La responsabile musicale <span className="text-[var(--pw-text)]">Lucia Porri</span> vi
              accompagna nella scelta della formazione e del repertorio: dal solista all'orchestra
              a parti reali, ogni cerimonia diventa una scena unica, scritta su misura per voi.
            </p>
            <p className="text-[var(--pw-gold)] italic font-serif text-xl md:text-2xl pt-4">
              "Dal sacro al civile, dal solenne al conviviale.
              <br />Ogni evento merita la sua musica."
            </p>
          </div>
        </motion.div>

        {/* Right image collage */}
        <motion.div
          variants={fade}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          className="lg:col-span-5 relative"
        >
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src="https://images.unsplash.com/photo-1465847899084-d164df4dedc6?auto=format&fit=crop&w=1200&q=80"
              alt="Quartetto d'archi"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-[var(--pw-gold)]/30" />
          </div>
          <div className="hidden md:block absolute -bottom-10 -left-10 w-48 h-64 overflow-hidden border border-[var(--pw-gold)]/40 bg-pw">
            <img
              src="https://images.unsplash.com/photo-1606216794074-735e91aa2c92?auto=format&fit=crop&w=600&q=80"
              alt="Violinista"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -top-6 -right-6 hidden md:flex flex-col items-center text-center font-serif">
            <div className="text-[var(--pw-gold)] text-6xl italic leading-none">10+</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[var(--pw-text)]/60 mt-2">
              Anni
            </div>
          </div>
        </motion.div>
      </div>

      {/* Stats */}
      <motion.div
        variants={fade}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.3 }}
        className="max-w-7xl mx-auto px-6 mt-24 md:mt-32 grid grid-cols-2 md:grid-cols-4 gap-y-10 border-t border-[var(--pw-border)] pt-12"
      >
        {STATS.map((s, i) => (
          <div
            key={s.label}
            className={`text-center md:text-left ${i !== 0 ? "md:border-l md:border-[var(--pw-border)] md:pl-8" : ""}`}
            data-testid={`stat-${i}`}
          >
            <div className="font-serif italic font-light text-5xl md:text-6xl text-[var(--pw-gold)] leading-none">
              {s.value}
            </div>
            <div className="mt-3 text-[10px] uppercase tracking-[0.28em] text-[var(--pw-text)]/60">
              {s.label}
            </div>
          </div>
        ))}
      </motion.div>
    </section>
  );
};

export default ChiSiamo;
